import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubble4: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-4, message, chat"><path d="M17.252 3C19.323 3 21.002 4.67893 21.002 6.75V16.25C21.002 18.3211 19.323 20 17.252 20H8.03875C7.99189 20 7.94598 20.0132 7.90625 20.038L4.14945 22.386C3.91825 22.5305 3.62684 22.5382 3.38838 22.406C3.14991 22.2738 3.00195 22.0226 3.00195 21.75V6.75C3.00195 4.67893 4.68089 3 6.75195 3H17.252Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBubble4;
